@if (loading) {
  <div class="page-loading">
    <span>
      <span></span>
    </span>
  </div>
}
@if (company) {
  <pc-bambuser-playlist />
  <div>
    @if (!company.Product.id) {
      <section class="product-contain {{ company.colour_scheme }}">
        <image-carousel [items]="company.CompanyImage" [slug]="company.slug" [scheme]="company.colour_scheme"
        [companyId]="company.id"></image-carousel>
        <h1>{{ company.title }}</h1>
        @if (company.group_id) {
          <section class="container">
            @if (isPartOfTheGroup()) {
              <p>
                <button class="secondary" (click)="leaveClub()">
                  <span class="fa fa-fw fa-thumbs-down"></span> Leave
                  {{ company.filter }}
                </button>
              </p>
            }
            @if (!isPartOfTheGroup()) {
              <div>
                <button (click)="joinClub()">
                  <span class="fa fa-fw fa-thumbs-up"></span> Join {{ company.filter }}
                </button>
              </div>
            }
          </section>
        }
        <p [innerHTML]="company.description"></p>
        <ul>
          @if (company.facebook_url) {
            <li>
              <a [href]="company.facebook_url"><span class="fa fa-fw fa-facebook"></span></a>
            </li>
          }
          @if (company.twitter_url) {
            <li>
              <a [href]="company.twitter_url"><span class="fa fa-fw fa-twitter"></span></a>
            </li>
          }
        </ul>
      </section>
    }
    @if (company.Product.id) {
      <section class="product-contain {{ company.colour_scheme }}">
        <image-carousel [items]="company.Product.ProductImage" [slug]="company.slug" [scheme]="company.colour_scheme"
        [companyId]="company.id"></image-carousel>
        <section class="container">
          <h1>{{ company.title }}</h1>
          <div class="product-price">
            <div class="price full-width">
              <p>
                {{ company.Product.price_label }}
                {{ company.Product.price_label_value }}
              </p>
            </div>
            <p class="definition ng-binding">
              {{ company.Product.price_terms }}
            </p>
          </div>
          @if (company.Product.ProductExtraInfo) {
            <extra-info [scheme]="company.colour_scheme" type="payment"
              [productInfo]="company.Product.ProductExtraInfo">
            </extra-info>
          }
        </section>
        @if (company.group_id && user) {
          <section class="container">
            @if (isPartOfTheGroup()) {
              <p>
                <button class="secondary" (click)="leaveClub()">
                  <span class="fa fa-fw fa-thumbs-down"></span> Leave
                  {{ company.filter }}
                </button>
              </p>
            }
            @if (!isPartOfTheGroup()) {
              <div>
                <button (click)="joinClub()">
                  <span class="fa fa-fw fa-thumbs-up"></span> Join
                  {{ company.filter }}
                </button>
              </div>
            }
          </section>
        }
        <div class="container product-content">
          <div class="product-description" [innerHTML]="company.Product.description"></div>
          @if (company.Product.ProductExtraInfo) {
            <extra-info type="product"
              [productInfo]="company.Product.ProductExtraInfo" [scheme]="company.colour_scheme">
            </extra-info>
          }
        </div>
      </section>
    }
    @if (showProducts()) {
      <section class="grid-layout" data-infinite-scroll="$ctrl.nextPage()"
        data-infinite-scroll-distance="0">
        <div class="row clearfix max-width">
          <div class="small-12 columns">
            <div>
              <h2>{{ company.title }} listings</h2>
            </div>
          </div>
        </div>
        <product-list [items]="company.listings"></product-list>
      </section>
    }
    @if (relatedContent && relatedContent.length > 0) {
      <div class="row clearfix max-width" style="margin-top: 20px">
        <div class="small-12 columns">
          <div>
            <h2>Related Pages</h2>
          </div>
        </div>
      </div>
    }
    @if (relatedContent && relatedContent.length > 0) {
      <cards-carousel [scheme]="relatedContent.colour_scheme"
      class="no-duplicate" overflow-scroll="true" [items]="relatedContent"></cards-carousel>
    }
  </div>
}
